import {
  createSeasonalChallengeRegistry,
  type SeasonalChallengeDescriptor,
} from "./seasonal-challenge-config";
import { halloween2026Season } from "../seasons/halloween-2026";

export const disabledSampleSeason = {
  accessibility: {
    arenaLabel: "Disabled sample seasonal arena",
    decorationsLabel: "Quiet sample arena accents",
    reducedMotionLabel: "All sample decorations remain still",
  },
  arena: {
    decorations: [
      {
        alpha: 0.1,
        heightRatio: 0.08,
        kind: "ellipse",
        reducedMotion: "static",
        widthRatio: 0.2,
        xRatio: 0.22,
        yRatio: 0.24,
      },
    ],
    highContrastPalette: {
      backgroundColor: 0x000000,
      boundaryColor: 0xffffff,
      boundaryOutlineColor: 0xfff7d6,
      decorationColor: 0xcbd5e1,
      fieldColor: 0x0f172a,
      foodHaloColor: 0xffffff,
      snakeOutlineColor: 0xffffff,
    },
    palette: {
      backgroundColor: 0x111827,
      boundaryColor: 0x475569,
      boundaryOutlineColor: 0xcbd5e1,
      decorationColor: 0x64748b,
      fieldColor: 0x1e293b,
      foodHaloColor: 0xfff7d6,
      snakeOutlineColor: 0xf8fafc,
    },
  },
  displayName: "Sample Season",
  enabled: false,
  home: {
    activeDescription: "1 minute · Sample arena",
    icon: "✦",
    upcomingDescription: "Coming soon",
  },
  mode: "challenge-1",
  results: {
    highlight: "Sample challenge complete",
    modeLabel: "Sample Season · 1 minute",
    outcome: "Season complete!",
  },
  rule: null,
  schedule: {
    endUtc: "2026-02-01T00:00:00.000Z",
    startUtc: "2026-01-01T00:00:00.000Z",
  },
  seedNamespace: "snakely:seasonal:v1:sample-season",
  share: {
    callToAction: "Can you beat it?",
    displayName: "Sample Season",
  },
  slug: "sample-season",
  version: 1,
} as const satisfies SeasonalChallengeDescriptor;

export const seasonalChallengeRegistry = createSeasonalChallengeRegistry([
  halloween2026Season,
  disabledSampleSeason,
]);
